import type { BiomeId } from './types';

export type TreeStage = 'sapling' | 'small' | 'adult' | 'ancient';

export interface Tree {
  id: string;
  biome: BiomeId;
  x: number;
  y: number;
  plantedAtMs: number;
  plantedByNpcId: string;
  stage: TreeStage;
  ageMs: number;
}

export const TREE_STAGE_DURATIONS: Record<TreeStage, number> = {
  sapling: 0,
  small: 24 * 60 * 60_000,
  adult: 7 * 24 * 60 * 60_000,
  ancient: 30 * 24 * 60 * 60_000,
};

export function treeStageFor(ageMs: number): TreeStage {
  if (ageMs >= TREE_STAGE_DURATIONS.ancient) return 'ancient';
  if (ageMs >= TREE_STAGE_DURATIONS.adult) return 'adult';
  if (ageMs >= TREE_STAGE_DURATIONS.small) return 'small';
  return 'sapling';
}

export function ageTree(tree: Tree, deltaMs: number): Tree {
  if (deltaMs <= 0) return tree;
  const ageMs = tree.ageMs + deltaMs;
  const stage = treeStageFor(ageMs);
  if (stage === tree.stage && ageMs === tree.ageMs) return tree;
  return { ...tree, ageMs, stage };
}

export interface WorldEvent {
  id: string;
  kind: 'tree-planted' | 'memorial' | 'species-discovered';
  biome: BiomeId;
  occurredAtMs: number;
  generation: number;
  payload: Record<string, unknown>;
}
